import { MemberStatusBadgeModule, SubgroupTabsModule } from '@schoolbelle/shared/components';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number'
import { SelectLetterTargetsStudentParentTabComponent } from './student-parent-tab.component';
import { EventSpyModule, TableModule } from '@schoolbelle/common/table';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';

@NgModule({
  imports: [
    MemberStatusBadgeModule,
    CommonModule,
    SubgroupTabsModule,
    TableModule,
    PhoneNumberModule.forRoot(),
    VirtualScrollerModule,
    EventSpyModule,
  ],
  declarations: [SelectLetterTargetsStudentParentTabComponent],
  exports:[SelectLetterTargetsStudentParentTabComponent],
})
export class SelectLetterTargetsStudentParentTabModule { }
